import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IFormTableType } from 'interfaces/forms';

import {
  halfRowInitialValues,
  IPeriodNames,
  IPeriodsTableRow,
  IPeriodValue,
  monthRowInitialValues,
  PERIOD_NAMES,
  quarterRowInitialValues,
  yearRowInitialValues,
} from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues } from 'components/BusinessToolForm/utils/helpers';

import { concatWithDot } from 'helpers/string';

import { INetIncomeFormValuesType, netIncomeInitialValues } from '../components/FormSections/NetIncome/utils/form';
import { NET_SALES_NAMES, netSalesInitialValues } from '../components/FormSections/NetSalesForm/utils/form';
import {
  OPERATING_EXPENSES_NAMES,
  operatingExpensesInitialValues,
} from '../components/FormSections/OperatingExpensesForm/utils/form';

export const FIRST_COLUMN_WIDTH = 210;

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN}.${BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.PROFIT_AND_LOSS_PROJECTION}` as const;

export const PROFIT_AND_LOSS_PROJECTION_FORM_NAMES = {
  CURRENCY: 'currency',
  TABLE: 'table',
  ESTIMATED_TAX_RATE: 'estimatedTaxRate',
  NET_SALES: 'netSales',
  OPERATING_EXPENSES: 'operatingExpenses',
  NET_INCOME: 'netIncome',
} as const;

export const netSalesPrefix = concatWithDot(prefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.NET_SALES);
export const operatingExpensesPrefix = concatWithDot(prefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.OPERATING_EXPENSES);
export const netIncomePrefix = concatWithDot(prefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.NET_INCOME);

export interface IProfitAndLossProjections {
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.TABLE]: IFormTableType;
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.NET_INCOME]: INetIncomeFormValuesType;
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.ESTIMATED_TAX_RATE]: number | '';
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.NET_SALES]: {
    [NET_SALES_NAMES.COST_OF_SALES]: IPeriodsTableRow;
    [NET_SALES_NAMES.GROSS_PROFIT]: IPeriodsTableRow;
    [NET_SALES_NAMES.NET_SALES]: IPeriodsTableRow;
    [NET_SALES_NAMES.INCOME]: IPeriodsTableRow;
  };
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.OPERATING_EXPENSES]: {
    [OPERATING_EXPENSES_NAMES.R_AND_D]: IPeriodsTableRow;
    [OPERATING_EXPENSES_NAMES.SALES_AND_MARKETING]: IPeriodsTableRow;
    [OPERATING_EXPENSES_NAMES.GENERAL_AND_ADMINISTRATIVE]: IPeriodsTableRow;
    [OPERATING_EXPENSES_NAMES.OTHER_OPERATING_EXPENSES]: IPeriodsTableRow;
    [OPERATING_EXPENSES_NAMES.TOTAL_OPERATING_EXPENSES]: IPeriodsTableRow;
  };
}

const initialValues: Record<IPeriodNames, IPeriodValue> = {
  [PERIOD_NAMES.QUARTER_VALUES]: quarterRowInitialValues,
  [PERIOD_NAMES.MONTH_VALUES]: monthRowInitialValues,
  [PERIOD_NAMES.HALF_VALUES]: halfRowInitialValues,
  [PERIOD_NAMES.YEAR_VALUES]: yearRowInitialValues,
};

export const profitAndLossProjectionInitialValues: IProfitAndLossProjections = {
  //delete table values as unnecessary table
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.TABLE]: getFormTableInitialValues(0, initialValues),
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.NET_INCOME]: netIncomeInitialValues,
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.ESTIMATED_TAX_RATE]: '',
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.NET_SALES]: netSalesInitialValues,
  [PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.OPERATING_EXPENSES]: operatingExpensesInitialValues,
};
